import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DemoMaterialModule } from '../demo-material-module';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SidebarComponent} from './sidebar/sidebar.component';
import { BreadcrumbComponent} from './breadcrumb/breadcrumb.component';
import { RightSidebarComponent } from './right-sidebar/rightsidebar.component';
import { SipJsService } from './service/sipjsServices.class';
import { MortgageModule } from './mortgage/mortgage.module';
import { FormdetailComponent } from './formdetail/formdetail.component';
import { AlertComponent} from './alert/alert.component';
import { PackageComponent } from './package/package.component';
import { DetailComponent} from './detail/detail.component';
import { UploadviewComponent } from './uploadview/uploadview.component';
import { ToggleComponent } from './toggle/toggle.component';
import { NotificationComponent } from './notification/notification.component';
import { NotificationService } from './notification/notification.service';
import { ContactComponent } from './contact/contact.component';
import { LeadComponent } from './lead/lead.component';
import { LeadlistComponent } from './leadlist/leadlist.component';
import { LookComponent } from './look/look.component';
import { WidgetGroupComponent } from './widget-group/widget-group.component';
import { MessageComponent } from './message/message.component';
import { ChatComponent } from './chat/chat.component';
import { ListmsgComponent } from './listmsg/listmsg.component';
import { BarcharComponent } from './barchar/barchar.component';
import { DialpadComponent } from '../dialer/dialpad/dialpad.component';
import { StatusComponent } from './status/status.component';
import { ScripteditorComponent } from './scripteditor/scripteditor.component';
import { CustomvariableComponent } from './scripteditor/customvariable/customvariable.component';
import { QuillModule } from 'ngx-quill';
import { ExportleadsComponent } from './exportleads/exportleads.component';
import { CkninjaeditorComponent } from './ckninjaeditor/ckninjaeditor.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { DialpersonalComponent } from '../dialer/dialpersonal/dialpersonal.component';
import { RestoreleadsComponent } from './restoreleads/restoreleads.component';
import { PdfviewerComponent } from './pdfviewer/pdfviewer.component';
import { TestemailComponent } from './testemail/testemail.component';
import { EdsourcecodeComponent } from './scripteditor/edsourcecode/edsourcecode.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SummaryComponent } from '../lead/summary/summary.component';
import { DiscoveryComponent } from '../lead/discovery/discovery.component';
import {ListleadComponent} from '../lead/listlead/listlead.component';
import { EmailEditorModule } from 'angular-email-editor';
import { UnlayerComponent } from './unlayer/unlayer.component';
import { CallforwordComponent } from './header-navigation/callforword/callforword.component'; 
import { ReportComponent, NgbdSortableHeader } from './report/report.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { widgetsComponent } from './widgets/widgets.component';
import { UncalledleadsComponent } from './uncalledleads/uncalledleads.component';
import { Uploadview1Component } from './uploadview1/uploadview1.component';
import { DialerService } from '../dialer/dialer.service';
import { InheritSMTPComponent } from './inherit-smtp/inherit-smtp.component';

@NgModule({
  imports:[
    CommonModule,
    RouterModule,
    DemoMaterialModule,
    FormsModule,
    ChartsModule,
    NgbModule,
    MortgageModule,
    QuillModule,
    ReactiveFormsModule,
    CKEditorModule,
    EmailEditorModule,
    NgApexchartsModule,
  ],
  
  declarations: [
    SidebarComponent,
    ReportComponent,   
    BreadcrumbComponent,
    RightSidebarComponent,
    FormdetailComponent,
    AlertComponent,
    PackageComponent,
    DetailComponent,
    UploadviewComponent,
    ToggleComponent,
    NotificationComponent,
    ContactComponent,
    LeadComponent,
    LeadlistComponent,
    LookComponent,
    WidgetGroupComponent,
    MessageComponent,
    ChatComponent,
    ListmsgComponent,
    BarcharComponent,
    DialpadComponent,
    StatusComponent,
    ScripteditorComponent,
    CustomvariableComponent,
    ExportleadsComponent,
    ExportleadsComponent,
    CkninjaeditorComponent,
    DialpersonalComponent,
    RestoreleadsComponent,
    PdfviewerComponent,
    TestemailComponent,
    EdsourcecodeComponent,  
    SummaryComponent, 
    DiscoveryComponent, 
    ListleadComponent,
    UnlayerComponent,
    CallforwordComponent,
    NgbdSortableHeader,
    widgetsComponent,
    UncalledleadsComponent,
    Uploadview1Component,
    InheritSMTPComponent,
  ],
  
  exports: [
    SidebarComponent,
    ReportComponent,    
    BreadcrumbComponent,
    RightSidebarComponent,
    FormdetailComponent,
    AlertComponent,
    PackageComponent,
    DetailComponent,
    UploadviewComponent,
    NotificationComponent,
    ContactComponent,
    LeadComponent,
    LeadlistComponent,
    ToggleComponent,
    LookComponent,
    WidgetGroupComponent,
    MessageComponent,
    ChatComponent,
    ListmsgComponent,
    BarcharComponent,
    DialpadComponent,
    StatusComponent,
    ScripteditorComponent,
    CustomvariableComponent,
    ExportleadsComponent,
    CkninjaeditorComponent,
    DialpersonalComponent,  
    SummaryComponent, 
    DiscoveryComponent, 
    ListleadComponent,
    UnlayerComponent,
    widgetsComponent,
    UncalledleadsComponent,
    Uploadview1Component,
    InheritSMTPComponent
   ],
   entryComponents: [DialpadComponent,CustomvariableComponent,CallforwordComponent,ExportleadsComponent,DialpersonalComponent, RestoreleadsComponent, PdfviewerComponent, TestemailComponent, EdsourcecodeComponent],
  providers: [SipJsService ,NotificationService,DialerService]

})

export class SharedModule { }